import { Download } from 'lucide-react';
import LlmsTxtForm from '../../../../components/LlmsTxtForm';
import { api } from '../../../../api/client';
import { toast } from '../../../../lib/toast';

export default function LlmsTxtFix({ domain, onFixApplied }) {
  const onDownload = async () => {
    try {
      const res = await api.get(`/api/domains/${domain._id}/llms-txt/raw`, {
        responseType: 'text',
        transformResponse: [(data) => data],
      });
      const blob = new Blob([res.data || ''], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'llms.txt';
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success('llms.txt downloaded');
      onFixApplied?.();
    } catch (err) {
      toast.error(err, 'Could not download llms.txt');
    }
  };

  return (
    <div className="space-y-4">
      <div className="text-sm text-ink-600">
        Configure how AI crawlers see your site, then download the generated
        <code className="mx-1 px-1.5 py-0.5 bg-gray-50 border border-gray-100 rounded text-xs">
          llms.txt
        </code>
        file and upload it to your domain root.
      </div>

      <LlmsTxtForm
        domainId={domain._id}
        domainHost={domain.domain}
        onSaved={onFixApplied}
      />

      <div className="border-t border-gray-100 pt-4">
        <button type="button" className="btn-primary" onClick={onDownload}>
          <Download className="w-4 h-4" />
          Download llms.txt
        </button>
        <ol className="list-decimal pl-5 mt-3 space-y-1 text-xs text-ink-600">
          <li>
            Drop the downloaded file at your web root (e.g. <code className="px-1 bg-gray-50 rounded">/var/www/{domain.domain}/llms.txt</code>).
          </li>
          <li>
            Verify it loads at <code className="px-1 bg-gray-50 rounded">https://{domain.domain}/llms.txt</code>.
          </li>
          <li>
            Re-run the audit — <strong>llms.txt published</strong> should now Pass.
          </li>
        </ol>
      </div>
    </div>
  );
}
